import { Command } from './types';
export { Command };
export class Api {
    constructor(transport = getTransport(), headers = {}) {
        this.transport = transport;
        this.headers = headers;
        // public host = 'https://fb.lecturekik.com';
        this.host = '';
        if (typeof process !== 'undefined' && process.env.API_HOST) {
            this.host = process.env.API_HOST;
        }
    }
    async get(cmd, ...params) {
        const url = this.constructUrl(cmd, params[0], true);
        return this.request(url);
    }
    async post(cmd, ...params) {
        const url = this.constructUrl(cmd, params[0]);
        return this.request(url, {
            method: 'POST',
            body: JSON.stringify(params[0] || {})
        });
    }
    async put(cmd, ...params) {
        const url = this.constructUrl(cmd, params[0]);
        return this.request(url, {
            method: 'PUT',
            body: JSON.stringify(params[0] || {})
        });
    }
    async request(url, init) {
        const { transport } = this;
        const headers = Object.assign({ 'Accept': 'application/json' }, this.headers);
        if (init === null || init === void 0 ? void 0 : init.body) {
            headers['Content-Type'] = 'application/json';
        }
        if (init === null || init === void 0 ? void 0 : init.headers) {
            Object.assign(headers, init.headers);
        }
        const resp = await transport(url, Object.assign(Object.assign({}, init), { credentials: 'include', mode: 'cors', headers }));
        const data = await resp.json();
        if (resp.ok && (data === null || data === void 0 ? void 0 : data.success) !== false) {
            return data;
        }
        // Произошла ошибка на сервере
        let code = resp.statusText;
        if ((data === null || data === void 0 ? void 0 : data.success) === false) {
            if (data.code && data.message) {
                code = `${data.code}.${data.message}`;
            }
            code = data.code || data.message || '';
        }
        throw createError(code, resp.status);
    }
    constructUrl(url, params, addToQuery = false) {
        const used = new Set();
        url = url.replace(/\{(\w+)\}/g, (str, name) => {
            if (!params || !(name in params)) {
                throw new Error(`Отсутствует требуемый параметр ${name}`);
            }
            used.add(name);
            return params[name];
        });
        // Добавляем GET-параметры
        if (params && addToQuery) {
            const query = [];
            Object.keys(params).forEach(key => {
                if (!used.has(key)) {
                    query.push(`${key}=${encodeURIComponent(String(params[key]))}`);
                }
            });
            if (query.length) {
                const glue = url.includes('?') ? '&' : '?';
                url += glue + query.join('&');
            }
        }
        return this.host + url;
    }
}
function getTransport() {
    if (typeof fetch !== 'undefined') {
        return fetch;
    }
    if (typeof this !== 'undefined' && this.fetch) {
        return this.fetch;
    }
    return () => {
        throw new Error('Fetch not implemented');
    };
}
export function createError(code, status) {
    const err = new Error(code);
    err.code = code;
    if (status) {
        err.status = status;
    }
    return err;
}
const api = new Api();
export default api;
